export enum RefreshType {
  Data = 1,
  UserSessionChange,
  ProjectSetupChange,
  AfterOfflineSync,
}
